/* Pop-up de captação: mostra na 1ª visita e volta a mostrar N minutos depois de fechado. */
(function () {
  if (customElements.get('popup-captacao')) return;

  class PopupCaptacao extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'fb:popup-captacao:closed-at';
      this.repeatMs = (parseInt(this.dataset.repeatMinutes, 10) || 60) * 60 * 1000;
      this.delayMs = (parseInt(this.dataset.delaySeconds, 10) || 0) * 1000;
      this.dialog = this.querySelector('.popup-captacao__dialog');

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-popup-close]')) {
          e.preventDefault();
          this.close();
        } else if (e.target.closest('[data-popup-cta]')) {
          this.remember();
          this.close(false);
        }
      });
      this.onKeydown = (e) => { if (e.key === 'Escape' && this.hasAttribute('open')) this.close(); };
      document.addEventListener('keydown', this.onKeydown);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          if (e.target.contains(this)) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.target.contains(this)) this.close(false);
        });
        if (this.dataset.designPreview === 'true') this.open();
        return;
      }

      if (this.shouldShow()) {
        setTimeout(() => this.open(), this.delayMs);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.style.overflow = '';
    }

    shouldShow() {
      try {
        const closedAt = parseInt(localStorage.getItem(this.storageKey), 10);
        if (!closedAt) return true;
        return Date.now() - closedAt >= this.repeatMs;
      } catch (err) {
        return true;
      }
    }

    remember() {
      try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (err) {}
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.hidden = false;
      this.previousFocus = document.activeElement;
      this.setAttribute('open', '');
      this.scrollLocked = document.body.style.overflow === '';
      if (this.scrollLocked) document.body.style.overflow = 'hidden';
      const closeBtn = this.querySelector('[data-popup-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    close(rememberClose = true) {
      if (!this.hasAttribute('open')) return;
      if (rememberClose) this.remember();
      this.removeAttribute('open');
      if (this.scrollLocked) document.body.style.overflow = '';
      if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus({ preventScroll: true });
    }
  }

  customElements.define('popup-captacao', PopupCaptacao);
})();
